import { render } from "./StrategyLab.vue?vue&type=template&id=67c7459f"
import script from "./StrategyLab.vue?vue&type=script&lang=js"
export * from "./StrategyLab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__